import React from 'react';

function EditProfileEmail() {
  const data = [
    {
      id: 1,
      label: 'Daily summary of chats, satisfaction rates, and missed opportunities',
      inputCheckBox: (
        <div className="Avaliable-Checkbox-main">
          <input
            type="checkbox"
            className="custom-checkbox"
            id={`checkbox${1}`}
          />
          <label htmlFor={`checkbox${1}`} />
        </div>
      ),
    },
    {
      id: 2,
      label: 'Weekly summary of chats, availability, response times, and team updates',
      inputCheckBox: (
        <div className="Avaliable-Checkbox-main">
          <input
            type="checkbox"
            className="custom-checkbox"
            id={`checkbox${2}`}
          />
          <label htmlFor={`checkbox${2}`} />
        </div>
      ),
    },
    {
      id: 3,
      label: 'New ticket notification',
      inputCheckBox: (
        <div className="Avaliable-Checkbox-main">
          <input
            type="checkbox"
            className="custom-checkbox"
            id={`checkbox${3}`}
          />

          <label htmlFor={`checkbox${3}`} />
        </div>
      ),
    },
    {
      id: 4,
      label: 'New unassigned chat',
      inputCheckBox: (
        <div className="Avaliable-Checkbox-main">
          <input
            type="checkbox"
            className="custom-checkbox"
            id={`checkbox${4}`}
          />
          <label htmlFor={`checkbox${4}`} />
        </div>
      ),
    },
  ];
  const labelStyle = {
    textTransform: 'capitalize',
    fontSize: '14px',
    color: '#405261',

    fontFamily: 'Inter, sans-serif',
    fontWeight: '400',

  };
  return (
    <div style={labelStyle} className="EditProfileEmail-Main-Container">
      {data.map((item) => (
        <div key={item.id} className="EditProfileEmail-Container">
          {item.inputCheckBox}
          {item.label}
        </div>
      ))}
    </div>
  );
}

export default EditProfileEmail;
